import outPutProductDialogReducer from './outPutProductDialogReducer';

export default outPutProductDialogReducer;